export const notificationSettingQuery = `
mutation saveNotificationsetting($obj:NotificationsettingInput!){
    saveNotificationsetting(obj:$obj){
      id
    }
  }
`;
